import { LockClosedIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'

export const NotAllowed = () => {
  return (
    <div className={'flex w-full h-full items-center justify-center'}>
      <div className={'flex flex-col items-center text-center mb-32 px-12'}>
        <LockClosedIcon className={'w-64 h-64 text-gray-200'} />
        <p className={'text-4xl text-gray-400 font-bold'}>
          Um diesen Bereich zu sehen fehlen dir Berechtigungen
        </p>
        <p className={'text-xl text-gray-400'}>
          Bitte wende dich an einen Bereichsleiter oder Administrator
        </p>
        <p className={'text-xl text-gray-400'}>
          Zurück zur <Link to={'/'}>Startseite</Link>
        </p>
      </div>
    </div>
  )
}
